module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073d7_banner_800x600.f6a9aca5.png";